<template>
  <div id="document-detail-list">
    <b-card no-body class="py-2 container-card mb-1">
      <b-row class="px-1 bg-dashboard">
        <b-col cols="12" class="px-2">
          <div class="title-header-detail">
            <div class="font-color head-label px-2">Mini Dashboard</div>
          </div>
        </b-col>
        <b-col cols="12">
          <overlay-loading :loading="loadingMiniDashboard">
            <template #content>
              <div class="row">
                <div
                  class="h-100"
                  :class="resolveLengthDynamicOverall ? 'col-12 ' : 'col p-1'"
                >
                  <div
                    class="d-flex flex-wrap"
                    :class="
                      resolveLengthDynamicOverall
                        ? ''
                        : 'justify-content-between'
                    "
                  >
                    <div
                      v-for="summaryObj in dataList.summary.payload"
                      :key="summaryObj.id"
                      :class="renderLayoutDynamicOverall"
                    >
                      <summary-dashboard
                        class="mr-3 w-100"
                        :summaryObj="summaryObj"
                        :hasMoreFour="resolveLengthDynamicOverall"
                      />
                    </div>
                  </div>
                </div>
                <div
                  class="col w-100"
                  :class="resolveLengthDynamicOverall ? '' : ' p-1'"
                >
                  <status-document
                    :statusData="dataList.statusDocument.payload"
                  />
                </div>
                <div
                  class="col w-100"
                  :class="resolveLengthDynamicOverall ? '' : ' p-1'"
                >
                  <admin :adminObj="dataList" />
                </div>
              </div>
            </template>
          </overlay-loading>
        </b-col>
      </b-row>
    </b-card>
    <b-card no-body class="py-2 container-card mb-1">
      <b-row class="px-1">
        <b-col cols="12" class="px-2">
          <div class="title-header-detail">
            <div class="font-color head-label px-2">Document List</div>
          </div>
        </b-col>
        <b-col cols="12" class="px-2 mb-1">
          <div class="header-detail-list">
            <div class="d-flex flex-wrap justify-content-end">
              <div class="mb-1 mt-2">
                <div class="row">
                  <div class="col">
                    <label class="font-medium-4"> Valid From</label>
                    <div class="d-flex align-items-end">
                      <div class="p-relative mr-1">
                        <calendar-picker-icon class="icon-calendar bypass" />
                        <flat-pickr
                          :id="'valid-from-date'"
                          v-model="form.validFromDate"
                          class="form-control bg-date"
                          :config="flatpickrDateConfig"
                          placeholder="Start Date"
                          required
                          autocomplete="off"
                        />
                      </div>
                      <div class="p-relative">
                        <clock-picker-icon
                          class="icon-calendar date-picker-icon bypass"
                        />
                        <flat-pickr
                          id="valid-from-time"
                          v-model="form.validFromTime"
                          class="form-control bg-date"
                          :class="form.validFromTime ? 'date-selected' : null"
                          :config="flatpickrTimeConfig"
                          :placeholder="'HH : mm'"
                          required
                          autocomplete="off"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row mr-2 mt-2">
                  <div class="col">
                    <label class="font-medium-4"> Valid Through</label>
                    <div class="d-flex align-items-end">
                      <div class="p-relative mr-1">
                        <calendar-picker-icon class="icon-calendar bypass" />
                        <flat-pickr
                          :id="'valid-from-date'"
                          v-model="form.validThroughDate"
                          class="form-control bg-date"
                          :class="
                            form.validThroughDate ? 'date-selected' : null
                          "
                          :config="flatpickrDateConfig"
                          placeholder="Start Date"
                          required
                          autocomplete="off"
                        />
                      </div>
                      <div class="p-relative">
                        <clock-picker-icon
                          class="icon-calendar date-picker-icon bypass"
                        />
                        <flat-pickr
                          id="valid-from-time"
                          v-model="form.validThroughTime"
                          class="form-control bg-date"
                          :class="
                            form.validThroughTime ? 'date-selected' : null
                          "
                          :config="flatpickrTimeConfig"
                          :placeholder="'HH : mm'"
                          required
                          autocomplete="off"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="header-line" />
              <div class="mb-1 mt-2">
                <div class="row ml-2 mr-2">
                  <div class="col d-flex align-items-end">
                    <div>
                      <label class="font-medium-4"> Status </label>
                      <v-select
                        id="campaign-type-status"
                        v-model="form.status"
                        class="v-select-filter mr-2 bg-dropdown"
                        :class="status ? 'v-select-filter-selected' : null"
                        placeholder="Status"
                        :options="statusOption"
                        :reduce="(option) => option.value"
                        @input="onSelectDocumentFilter('status', form.status)"
                      />
                    </div>
                    <div class="search-container mb-md-0 mr-0 ml-0 search-wrp">
                      <label class="font-medium-4"> Name/Mobile No./Pop </label>
                      <search
                        :on-search-input="
                          (e) => onSelectDocumentFilter('query', e)
                        "
                      />
                    </div>
                  </div>
                </div>
                <div class="row ml-2 mt-2">
                  <div class="col d-flex align-items-end">
                    <div
                      class="search-container mb-md-0 mr-0 ml-0 mr-2 search-wrp"
                    >
                      <div class="font-medium-4" />
                      <label class="font-medium-4"> Document No. </label>
                      <search
                        :on-search-input="
                          (e) => onSelectDocumentFilter('docno', e)
                        "
                      />
                    </div>
                    <div
                      class="search-container mb-md-0 mr-0 ml-0 mr-2 search-wrp"
                    >
                      <div class="font-medium-4" />
                      <label class="font-medium-4"> Custom Field </label>
                      <search
                        :on-search-input="
                          (e) => onSelectDocumentFilter('custom', e)
                        "
                      />
                    </div>
                    <b-button
                      class="
                        d-flex
                        align-items-center
                        justify-content-center
                        btn-search-wrp btn-font-color
                        font-medium-5
                      "
                      @click="getDocumentList(true, true)"
                    >
                      <feather-icon icon="SearchIcon" class="mr-2" />
                      <span>Search</span>
                    </b-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-col>
        <b-col cols="12" class="mb-1">
          <overlay-loading :loading="loading.tableData">
            <template #content>
              <b-table
                :fields="fields"
                :items="documentDetailTable.payload"
                responsive
                bordered
                borderless
                sticky-header
                show-empty
                class="default-static-table"
              >
                <template #head(seq)="data">
                  <div class="text-center">
                    {{ data.label }}
                  </div>
                </template>
                <template #head(document_id)="data">
                  <div class="text-center">
                    {{ data.label }}
                  </div>
                </template>
                <template #head(image)="data">
                  <div class="text-center">
                    {{ data.label }}
                  </div>
                </template>
                <template #cell(seq)="data">
                  <div class="text-center">
                    {{ data.index + 1 }}
                  </div>
                </template>
                <template #cell(document_id)="data">
                  <div class="text-center">
                    {{ data.value }}
                  </div>
                </template>
                <template #cell(image)="data">
                  <div class="d-flex justify-content-center">
                    <img :src="data.value || DefaultImg" class="image-column" />
                  </div>
                </template>
                <template #cell(status)="data">
                  <div class="d-flex align-items-center">
                    <feather-icon
                      icon="CircleIcon"
                      class="mr-2"
                      :class="resolveStatusClass(data.item.status)"
                    />

                    <span class="font-color">{{
                      resolveStatusLabel(data.item.status)
                    }}</span>
                  </div>
                </template>
                <template #cell(actions)="data">
                  <div class="cursor-pointer">
                    <b-link
                      :to="routeDocumentInfo(data.item.document_id)"
                      class="d-flex align-items-center"
                    >
                      <icon-next
                        @click.native="routeDocumentInfo(data.item.document_id)"
                      />
                    </b-link>
                  </div>
                </template>
                <template #table-busy>
                  <overlay-loading :loading="true" />
                </template>
                <template #empty>
                  <card-no-item :text-no-img="'Item Not Found'" />
                </template>
              </b-table>
            </template>
          </overlay-loading>
        </b-col>
        <b-col cols="12" class="my-1 px-2">
          <pagination-with-reorder
            :pagination="pagination"
            entity-editable
            @entityChange="onFilterEntity"
            @pageChange="onPageChange"
          />
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import {
  BCol,
  BCard,
  BTable,
  BFormCheckbox,
  BRow,
  BSpinner,
} from "bootstrap-vue";
import CardNoItem from "@core/components/card-no-item/CardNoItem.vue";
import Search from "@/views/components/search/Search.vue";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import CalendarPickerIcon from "@/@core/components/svg/common/CalendarPicker.vue";
import ClockPickerIcon from "@/@core/components/svg/common/ClockPicker.vue";

import IconNext from "@/@core/components/svg/common/IconNext.vue";
import DefaultImg from "@/assets/images/icons/no-img-square.jpg";
import PaginationWithReorder from "@/views/components/pagination/PaginationWithReorder.vue";
import useDocumentDetail from "./hooks/useDocumentDetail";
import SummaryDashboard from "./components/SummaryDashboard.vue";
import StatusDocument from "./components/StatusDocument.vue";
import Admin from "./components/Admin.vue";

import useDashboardDetail from "./hooks/useDashboardDetail";
import OverlayLoading from "@/views/components/loading/OverlayLoading.vue";

import router from "@/router";

export default {
  components: {
    BCol,
    BCard,
    BTable,
    BFormCheckbox,
    BRow,
    BSpinner,
    CardNoItem,
    Search,
    vSelect,
    IconNext,
    flatPickr,
    CalendarPickerIcon,
    ClockPickerIcon,
    SummaryDashboard,
    StatusDocument,
    Admin,
    PaginationWithReorder,
    OverlayLoading,
  },

  setup(props) {
    const {
      fields,
      loading,
      statusOption,
      status,
      form,
      documentDetailTable,
      pagination,
      onPageChange,
      onFilterEntity,
      resolveStatusLabel,
      resolveStatusClass,
      getDocumentList,
      onSelectDocumentFilter,
      routeDocumentInfo,

      validFrom,
      validThrough,
      flatpickrDateConfig,
      flatpickrTimeConfig,
      onOpenValidFromDatePicker,
      onOpenValidFromTimePicker,
      onOpenValidThroughTimePicker,
      onSelectValidFromDate,
      onSelectValidFromTimePicker,
      resolveDateString,
    } = useDocumentDetail();

    const {
      loadingMiniDashboard,
      dataList,
      renderLayoutDynamicOverall,
      resolveLengthDynamicOverall,
    } = useDashboardDetail(props);

    return {
      DefaultImg,
      routeDocumentInfo,
      fields,
      loading,
      statusOption,
      status,
      form,
      documentDetailTable,
      pagination,
      onPageChange,
      onFilterEntity,
      resolveStatusLabel,
      resolveStatusClass,
      getDocumentList,
      onSelectDocumentFilter,

      validFrom,
      validThrough,
      flatpickrDateConfig,
      flatpickrTimeConfig,
      onOpenValidFromDatePicker,
      onOpenValidFromTimePicker,
      onOpenValidThroughTimePicker,
      onSelectValidFromDate,
      onSelectValidFromTimePicker,
      resolveDateString,

      dataList,
      loadingMiniDashboard,
      renderLayoutDynamicOverall,
      resolveLengthDynamicOverall,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>

<style scoped>
@import "~@/assets/css/pages/document-detail/document-detail.css";
@import "~@/assets/css/pages/default-static-table.css";
@import "~@/assets/css/override-styles/v-select.css";
@import "~@/assets/css/override-styles/dynamic-fields.css";
@import "~@/assets/css/override-styles/status.css";
@import "~@/assets/css/pages/data-management.css";
</style>
